import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { homeURL } from "./helpers/paths";
import Home from "./pages/Homepage/Home";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import QuoteForm from "./components/QuoteForm/QuoteForm";

const Routing = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Header quoteLink={handleShow} />
      <Routes>
        <Route path={homeURL} element={<Home />} />
        {/* <Route exact path="/404" element={<NotFound />} /> */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <QuoteForm show={show} onHide={() => setShow(false)} />
      <Footer />
    </>
  );
};

export default Routing;
